import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    tagName: 'tr',

    events: {
        'click .edit'   : 'edit',
        'click .revoke' : 'revoke',
        'click .share'  : 'share',
        'click .lock'   : 'lock'
    },

    dom_handlers: {
        lock: function() {
            Modals.unlockFeature('Extension key is not available in your plan.<br>Upgrade your account to get access.', 'Let\'s Go');
        },

        edit: function(e) {
            Modals.editExtensionKey(this.model.id);
        },

        revoke: function(e) {
            Modals.deleteExtensionKey(this.model.id);
        },

        share: function(e) {
            Modals.shareExtensionKey(this.model.id);
        }
    },

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);
    },

    render: function() {
        var content = '';

        var user       = Cache.user.get(this.model.get('user_id'));
        var project    = Cache.project.get(this.model.get('project_id'));

        var created_by   = user ? user.escape('name') : '<span class="strike">Deleted user</span>';
        var project_name = project ? project.escape('name') : '<span class="strike">Deleted project</span>';

        content += '<td>' + (Cache.account.hasFeature('extension_key') ? '' : '<span class="lock tooltip" data-title="The key is disabled"><i class="fas fa-lock-alt text-warning"></i></span> ') + this.model.escape('name') + '</td>' +
                    '<td>' + project_name + '</td>' +
                    '<td>'+ Util.moment(this.model.get('last_accessed'), undefined, undefined, undefined, 'Never accessed') + '</td>' +
                    '<td>' + created_by + '<br><span class="info">' + Util.moment(this.model.get('create_time')) + '</span></td>' +
                    '<td class="text-align-right">' +

                        '<div class="button-dropdown">' +
                            '<button class="ellipsis"><i class="fa-regular fa-ellipsis-h"></i></button>' +
                            '<div>' +
                                '<ul class="dropdown">' +
                                    '<li class="share">View and Share</li>' +
                                    '<li class="edit">Edit</li>' +
                                    '<li class="separator"></li>' +
                                    '<li class="revoke danger">Revoke</li>' +
                                '</ul>' +
                            '</div>' +
                        '</div>' +
                    '</td>';

        this.$el.html(content);

        return this;
    }
});